import React from "react";

import { RegularButton } from "colbi_web_ui/lib/components/inputs";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

import styles from "./RawData.module.sass";

const RawData = (props) => {
    const { label, data, entity } = props;
    const { pushModal, i18n } = useGlobalValue();

    if (!data) {
        return null;
    }

    return (
        <div className={`${styles["button"]} ${styles["raw-data"]}`}>
            <RegularButton
                children={label}
                onClick={() => {
                    pushModal({
                        title: label,
                        data: { data, entity: `${i18n`${entity}`}` },
                        args: "",
                        view: "JsonViewer",
                    }).catch(() => null);
                }}
            >
                {i18n`${label}`}
            </RegularButton>
        </div>
    );
};

export default RawData;
